import { PageAction } from "./page.action";

export const DEFAULT_PAGE_CONTENT_TYPE = "general";

export const PAGE_MESSAGE_CONTEXT = {
	setCurrent: PageAction.setCurrent.type,
};
